// Argentine names + provinces for social proof notifications.

export const ARGENTINE_NAMES: string[] = [
  'Sofía M.',
  'Camila R.',
  'Martina G.',
  'Lucía F.',
  'Valentina P.',
  'Florencia D.',
  'Agustina B.',
  'Brenda L.',
  'Daniela S.',
  'Julieta V.',
  'Carolina A.',
  'Micaela O.',
  'Belén T.',
  'Antonella C.',
  'Rocío N.',
  'Macarena I.',
  'Ailén E.',
  'Romina H.',
  'Gabriela Z.',
  'Mariana K.',
  'Paula U.',
  'Yamila Y.',
  'Solange Q.',
  'Tatiana W.',
  'Pilar X.',
  'Renata J.',
  'Abril RN.',
  'Catalina J.',
  'Mía D.',
  'Bianca S.',
]

export const ARGENTINE_PROVINCES: string[] = [
  'Buenos Aires',
  'CABA',
  'Córdoba',
  'Mendoza',
  'Santa Fe',
  'Tucumán',
  'Salta',
  'Entre Ríos',
  'Misiones',
  'Chaco',
  'Corrientes',
  'Neuquén',
  'Río Negro',
  'San Juan',
  'Jujuy',
  'Formosa',
  'San Luis',
  'Catamarca',
  'La Rioja',
  'La Pampa',
  'Santiago del Estero',
  'Chubut',
  'Santa Cruz',
  'Tierra del Fuego',
]
